const ClubAppDashboard = () => {
  return <div>ClubAppDashboard</div>;
};

export default ClubAppDashboard;
